














































































import Vue from 'vue';
import {Channel, ChannelTypeEnum} from '@/types/channel';
import {ChannelApi} from '@/api/channel-api';
import {RoutsData} from '@/router/routs';
import {SavedCameraType} from '@/types/camera-type';
import {CameraApi} from '@/api/camera-api';

let channelId: string;
export default Vue.extend({
  name: 'Channel',
  created() {
    channelId = this.$route.params.channelId;
    if (channelId) {
      ChannelApi.getOne(channelId as string).then((res: any) => {
        this.channel = res.data;
        this.channelConfig = JSON.stringify(res.data.config);
      });
      CameraApi.getListByParam(`s={"channel": "${channelId}"}`).then(res => {
        this.cameras = res.data;
      });
    }
  },
  data() {
    return {
      channel: new Channel(),
      channelTypeEnum: Object.keys(ChannelTypeEnum),
      channelConfig: '',
      cameras: [] as SavedCameraType[],
      load: false
    };
  },
  computed: {
    isSave(): boolean {
      return channelId != undefined;
    }
  },
  methods: {
    onSave() {
      try {
        this.channel.config = JSON.parse(this.channelConfig || '{}');

        ChannelApi.save(this.channel).then(res => {
          this.$store.commit('setMessage', {
            show: true,
            text: 'Изменения сохранены'
          });

          this.channel = res.data;
          this.channelConfig = JSON.stringify(res.data.config);

          this.$router.push({name: RoutsData.CHANNEL.name, params: {channelId: res.data.id.toString()}});
        });
      } catch (e) {
        this.$store.commit('setMessage', {
          show: true,
          text: 'В конфигирация канала должна представлять собой валидный json'
        });
      }
    }
  }
});
